import { Navigate } from "react-router-dom";
import useBusiness from "@/core/business/use-business";
import PostOnboardingItems from "./post-onboarding/post-onboarding-items";
import WaitingPageLayout from "./waiting-page-layout";

const WaitingForPhoneNumber = () => {
  const { selectedBusiness } = useBusiness();

  const isPhoneNumberVerified =
    selectedBusiness && selectedBusiness?.phone_number;

  if (isPhoneNumberVerified) {
    return <Navigate to="/" />;
  }

  return (
    <WaitingPageLayout
      headline="We are working to set up your referral hotline"
      body="We are currently working on getting your new phone number set up for you on our end. Expect updates from our team before this portal refreshes. More to come soon!"
    >
      <PostOnboardingItems />
    </WaitingPageLayout>
  );
};

export default WaitingForPhoneNumber;
